import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 10px;
  max-height: 36px;
  width: 100%;
  margin-top: 10px;
  gap: 24px;
  justify-content: center;
`;

export const BrandLogo = styled.img`
  height: auto;
  max-width: 90px;
  object-fit: contain;
  object-position: center;
`;
